import { render, staticRenderFns } from "./ImageAdmin.vue?vue&type=template&id=0195b0dc&scoped=true&"
import script from "./ImageAdmin.vue?vue&type=script&lang=js&"
export * from "./ImageAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ImageAdmin.vue?vue&type=style&index=0&id=0195b0dc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0195b0dc",
  null
  
)

export default component.exports